(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voms-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const LEAVE_CLASSES = ['is-leaving-left','is-leaving-right','is-leaving-up','is-leaving-down','is-entering-left','is-entering-right','is-entering-up','is-entering-down'];
    const instances = new WeakMap();
    function clearAnimClasses(el) { LEAVE_CLASSES.forEach((c) => el.classList.remove(c)); }
    function destroySlider(slider) {
      const inst = instances.get(slider);
      if (!inst) return;
      if (inst.timer) window.clearInterval(inst.timer);
      if (inst.safetyTimer) window.clearTimeout(inst.safetyTimer);
      inst.abortController.abort();
      instances.delete(slider);
      slider.removeAttribute('data-voms-hero-initialized');
    }
    function initSlider(slider) {
      if (!slider || slider.hasAttribute('data-voms-hero-initialized')) return;
      const card = slider.querySelector('[data-slider-card]');
      const slides = Array.from(slider.querySelectorAll('[data-slider-slide]'));
      if (!card || slides.length <= 1) return;
      const dots = Array.from(slider.querySelectorAll('[data-slider-dot]'));
      const autoplay = slider.dataset.autoplay === 'true';
      const speed = parseInt(slider.dataset.autoplaySpeed, 10) || 6000;
      const animation = slider.dataset.animation || 'fade';
      const transitionMs = parseInt(slider.dataset.transitionMs, 10) || 800;
      const abortController = new AbortController();
      const signal = abortController.signal;
      let index = slides.findIndex((s) => s.classList.contains('is-active'));
      if (index < 0) index = 0;
      let timer = null;
      let safetyTimer = null;
      let touchStartX = 0;
      let isAnimating = false;
      const unlock = () => { isAnimating = false; if (safetyTimer) { window.clearTimeout(safetyTimer); safetyTimer = null; } };
      const lock = () => { isAnimating = true; if (safetyTimer) window.clearTimeout(safetyTimer); safetyTimer = window.setTimeout(unlock, transitionMs + 200); };
      const syncDots = (activeIndex) => { dots.forEach((dot, i) => { const isActive = i === activeIndex; dot.classList.toggle('is-active', isActive); dot.setAttribute('aria-selected', isActive ? 'true' : 'false'); }); };
      const goTo = (nextIndex, dir) => {
        if (isAnimating) return;
        const normalized = (nextIndex + slides.length) % slides.length;
        if (normalized === index) return;
        const direction = dir || (normalized > index ? 'next' : 'prev');
        const current = slides[index];
        const next = slides[normalized];
        lock();
        clearAnimClasses(current);
        clearAnimClasses(next);
        if (animation === 'fade') {
          current.classList.remove('is-active');
          next.classList.add('is-active');
          index = normalized;
          syncDots(index);
          window.setTimeout(unlock, transitionMs);
          return;
        }
        const enterClass = animation === 'slide-left' ? (direction === 'next' ? 'is-entering-right' : 'is-entering-left') : (direction === 'next' ? 'is-entering-down' : 'is-entering-up');
        const leaveClass = animation === 'slide-left' ? (direction === 'next' ? 'is-leaving-left' : 'is-leaving-right') : (direction === 'next' ? 'is-leaving-up' : 'is-leaving-down');
        next.classList.add(enterClass);
        void next.offsetHeight;
        current.classList.remove('is-active');
        current.classList.add(leaveClass);
        next.classList.remove(enterClass);
        next.classList.add('is-active');
        index = normalized;
        syncDots(index);
        window.setTimeout(() => { clearAnimClasses(current); unlock(); }, transitionMs + 50);
      };
      const goNext = () => goTo(index + 1, 'next');
      const goPrev = () => goTo(index - 1, 'prev');
      const stopAutoplay = () => { if (timer) { window.clearInterval(timer); timer = null; } };
      const startAutoplay = () => { if (!autoplay) return; stopAutoplay(); timer = window.setInterval(goNext, speed); };
      card.addEventListener('click', (event) => {
        if (event.target.closest('[data-slider-prev]')) { event.preventDefault(); goPrev(); startAutoplay(); return; }
        if (event.target.closest('[data-slider-next]')) { event.preventDefault(); goNext(); startAutoplay(); return; }
        const dot = event.target.closest('[data-slider-dot]');
        if (dot) { event.preventDefault(); const target = parseInt(dot.dataset.sliderDot, 10); if (Number.isNaN(target)) return; goTo(target, target > index ? 'next' : 'prev'); startAutoplay(); }
      }, { signal });
      slider.addEventListener('touchstart', (e) => { touchStartX = e.changedTouches[0].screenX; }, { passive: true, signal });
      slider.addEventListener('touchend', (e) => { const diff = e.changedTouches[0].screenX - touchStartX; if (Math.abs(diff) < 50) return; if (diff > 0) goPrev(); else goNext(); startAutoplay(); }, { passive: true, signal });
      slider.addEventListener('mouseenter', stopAutoplay, { signal });
      slider.addEventListener('mouseleave', startAutoplay, { signal });
      syncDots(index);
      startAutoplay();
      instances.set(slider, { timer, safetyTimer, abortController });
      slider.setAttribute('data-voms-hero-initialized', 'true');
    }
    function initAll(root) { (root || document).querySelectorAll('[data-voms-hero-slider]').forEach(initSlider); }
    function onSectionLoad(event) { const s = event.target.querySelector('[data-voms-hero-slider]') || event.target.closest('[data-voms-hero-slider]'); if (s) { destroySlider(s); initSlider(s); } }
    function onSectionUnload(event) { const s = event.target.querySelector('[data-voms-hero-slider]') || event.target.closest('[data-voms-hero-slider]'); if (s) destroySlider(s); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', () => initAll()); } else { initAll(); }
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:reorder', onSectionLoad);
  })();

  } catch(e) { console.error(e); }
})();
})();
